/**
 * Единый блок настроек: лейбл, описание (опционально), контент.
 * nested — для вложенных блоков (Базовый промпт, Дополнительные промпты внутри Системного).
 */
export default function SettingsBlock({ label, description, children, nested = false, className = '' }) {
  const blockClass = nested ? 'settings-block settings-block--nested' : 'settings-block'
  return (
    <div className={`${blockClass} ${className}`.trim()}>
      <h3 className="settings-block-label">{label}</h3>
      {description && <p className="settings-block-desc">{description}</p>}
      <div className="settings-block-content">{children}</div>
    </div>
  )
}
